export const loadJSON = (key, defaultValue = {}) => {
  try {
    return JSON.parse(loadString(key, defaultValue));
  } catch (err) {
    return defaultValue;
  }
};

export const saveJSON = (key, value) => {
  try {
    saveString(key, JSON.stringify(value));
  } catch (err) {
    console.error(err); // eslint-disable-line
  }
};


export const loadString = (key, defaultValue = '') => {
  try {
    const serialized = localStorage.getItem(key);
    if (serialized === null) {
      return defaultValue;
    }
    return serialized;
  } catch (err) {
    return defaultValue;
  }
};


export const saveString = (key, value) => {
  try {
    localStorage.setItem(key, value);
  } catch (err) {
    console.error(err); // eslint-disable-line
  }
};

export default {
  json: {
    save: saveJSON,
    load: loadJSON,
  },
  string: {
    save: saveString,
    load: loadString,
  },
};
